import { fetchClient } from "@babackapp/private-api-client/generated/client";
import { useQuery } from "@tanstack/react-query";

export type ProductRecommendationShopMeta = {
  id: string;
  shopId: string;
  shopName: string | null;
  lastOrderPairConsolidation: number | null;
  lastCustomerPairConsolidation: number | null;
  lastScoreComputation: number | null;
  totalOrderPairs: number | null;
  totalCustomerPairs: number | null;
  totalRecommendations: number | null;
};

// Cast to bypass strict openapi-fetch typing for internal endpoints
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const untypedGet = fetchClient.GET as unknown as (url: string) => Promise<{
  data: ProductRecommendationShopMeta[] | undefined;
  error: unknown;
}>;

export function useProductRecommendationStatus() {
  return useQuery({
    queryKey: ["product-recommendation-status"],
    queryFn: async () => {
      const { data, error } = await untypedGet(
        "/internal/product-recommendations/status",
      );
      if (error) throw error;
      return data ?? [];
    },
    staleTime: 30_000,
  });
}
